import { render, staticRenderFns } from "./ChannelSalesCard.vue?vue&type=template&id=39eb26bc&scoped=true"
import script from "./ChannelSalesCard.vue?vue&type=script&lang=js"
export * from "./ChannelSalesCard.vue?vue&type=script&lang=js"
import style0 from "./ChannelSalesCard.vue?vue&type=style&index=0&id=39eb26bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eb26bc",
  null
  
)

export default component.exports